import React, { useEffect, useMemo, useState } from "react";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";

type PersonOption = { id: number | string; name: string };

interface SignatureBlockProps {
    peopleOptions: PersonOption[];
    className?: string;

    // opcionais (se quiser controlar por fora)
    thermographerId?: string | number;
    managerId?: string | number;

    // opcionais (para persistir no pai)
    onThermographerChange?: (id: string) => void;
    onManagerChange?: (id: string) => void;
}

const SignatureBlock = ({
    peopleOptions,
    className,
    thermographerId,
    managerId,
    onThermographerChange,
    onManagerChange,
}: SignatureBlockProps) => {
    const { t } = useTranslation();
    const tt = (key: string, options?: Record<string, unknown>) => t(key, { ns: "translation", ...options });

    // estado interno (garante que "fica selecionado")
    const [localThermographerId, setLocalThermographerId] = useState<string>("");
    const [localManagerId, setLocalManagerId] = useState<string>("");

    // se vier valor externo, sincroniza (sem resetar toda hora)
    useEffect(() => {
        if (thermographerId !== undefined) setLocalThermographerId(String(thermographerId ?? ""));
    }, [thermographerId]);

    useEffect(() => {
        if (managerId !== undefined) setLocalManagerId(String(managerId ?? ""));
    }, [managerId]);

    const thermographerName = useMemo(() => {
        return peopleOptions.find((x) => String(x.id) === String(localThermographerId))?.name ?? "--";
    }, [peopleOptions, localThermographerId]);

    const managerName = useMemo(() => {
        return peopleOptions.find((x) => String(x.id) === String(localManagerId))?.name ?? "--";
    }, [peopleOptions, localManagerId]);

    return (
        <div className={`thermo-report__signatures ${className ?? ""}`}>
            {/* Termografista */}
            <div className="thermo-report__signature">
                <div className="thermo-report__signature-line" />

                <Form.Select
                    className="phoenix-native thermo-report__signature-selectInput no-print"
                    name="thermographerId"
                    value={localThermographerId}
                    onChange={(e) => {
                        const v = e.target.value; // sempre string
                        setLocalThermographerId(v);
                        onThermographerChange?.(v);
                    }}
                >
                    <option value="">{tt("pages.thermography.signatureBlock.selectThermographer")}</option>
                    {peopleOptions.map((p) => (
                        <option key={p.id} value={String(p.id)}>
                            {p.name}
                        </option>
                    ))}
                </Form.Select>

                <div className="thermo-report__signature-text">
                    <div className="thermo-report__signature-name">{thermographerName}</div>
                    <div className="thermo-report__signature-role">{tt("pages.thermography.signatureBlock.thermographer")}</div>
                </div>
            </div>

            {/* Gerente */}
            <div className="thermo-report__signature">
                <div className="thermo-report__signature-line" />

                <Form.Select
                    className="phoenix-native thermo-report__signature-selectInput no-print"
                    name="managerId"
                    value={localManagerId}
                    onChange={(e) => {
                        const v = e.target.value;
                        setLocalManagerId(v);
                        onManagerChange?.(v);
                    }}
                >
                    <option value="">{tt("pages.thermography.signatureBlock.selectManager")}</option>
                    {peopleOptions.map((p) => (
                        <option key={p.id} value={String(p.id)}>
                            {p.name}
                        </option>
                    ))}
                </Form.Select>

                <div className="thermo-report__signature-text">
                    <div className="thermo-report__signature-name">{managerName}</div>
                    <div className="thermo-report__signature-role">{tt("pages.thermography.signatureBlock.manager")}</div>
                </div>
            </div>
        </div>
    );
};

export default SignatureBlock;
